export default __webpack_public_path__ + "static/media/border-bottom_pc@2x.eee2baeb.png";